export default __webpack_public_path__ + "static/media/23.05f3cec9.jpg";